import React, {useState} from 'react';
import {member} from "../../../models/member";
import {useForm} from "react-hook-form";
import {ApiError, ApiService} from "../../../service/ApiService";
import {scrollTo} from "../../../service/ToolsService";
import {Require} from "../Require";
import {NavLink, useNavigate} from "react-router-dom";
import {ImageUpload} from "../ImageUpload";

type FormDataType = {
  name?: string;
  firstname?: string;
  email?: string;
  avatar?: string;
}

type MemberFormProps = {
  member?: member,
}

export const MemberForm = ({member}: MemberFormProps) => {
  const navigate = useNavigate();

  const [image, setImage] = useState(undefined as undefined | string);

  const {
    register,
    handleSubmit,
    setError,
    formState: {errors}
  } = useForm<FormDataType>({
    defaultValues: {
      name: member?.name,
      firstname: member?.firstname,
      email: member?.email,
    }
  });

  const onSubmit = async (data: FormDataType) => {
    const avatar: undefined | string = image;

    const m = {
      name: data.name,
      firstname: data.firstname,
      email: data.email || undefined,
      avatar: avatar,
    };

    try {
      if (member) {
        await ApiService.patch(`/member/${member.memberId}`, {param: () => m})
      } else {
        await ApiService.post('/member', {param: () => m})
      }

      navigate('/admin/office/member');
      scrollTo();
    } catch (e: any) {
      const error: ApiError = e as ApiError;

      error.errors?.forEach((e: {
        field: string,
        message: string
      }) => {
        setError(e.field as "name" | "firstname" | "email" | "avatar", {
          type: "manual",
          message: e.message
        })
      });

    }
  }

  return (
    <form className="p-3" method="post" onSubmit={handleSubmit(onSubmit)}>
      <div className="d-flex">
        <div className="col max-w600px pe-4">
          <div className="mb-3">
            <label className="form-name" htmlFor="form-name">Nom <Require/></label>
            <input id="form-name" type="text" className="form-control" placeholder="~" {...register('name', {
              required: 'Le nom est obligatoire',
              validate: {
                minLength: (value) =>
                  (value ?? '').length <= 255 || 'Le nom ne doit pas dépasser 255 caractères',
              },
            })} />
            {errors.name && <p className="text-danger">{errors.name.message}</p>}
          </div>
          <div className="mb-3">
            <label className="form-firstname" htmlFor="form-firstname">Prénom <Require/></label>
            <input id="form-firstname" type="text" className="form-control" placeholder="~" {...register('firstname', {
              required: 'Le prénom est obligatoire',
              validate: {
                minLength: (value) =>
                  (value ?? '').length <= 255 || 'Le prénom ne doit pas dépasser 255 caractères',
              },
            })} />
            {errors.firstname && <p className="text-danger">{errors.firstname.message}</p>}
          </div>
          <div className="mb-3">
            <label className="form-email" htmlFor="form-email">Email</label>
            <input id="form-email" type="text" className="form-control" placeholder="~" {...register('email', {
              validate: {
                minLength: (value) =>
                  (value ?? '').length <= 255 || 'L\'email ne doit pas dépasser 255 caractères',
              },
            })} />
            {errors.email && <p className="text-danger">{errors.email.message}</p>}
          </div>
        </div>
        <div className="col max-w600px pe-4">
          <ImageUpload label="Avatar" current={member?.avatar} maxSize={600}
                       error={errors.avatar?.message} change={setImage}/>
        </div>
      </div>
      <div className="mt-3">
        <button className="btn btn-sm btn-success me-1" type="submit">Enregistrer</button>
        <NavLink to={`/admin/office/member`} onClick={scrollTo} className="btn btn-sm btn-info">Retour aux membres</NavLink>
      </div>
    </form>
  )
}
